import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { BaseEntityResponseDto } from '@sphere/shared/domain'

class ActivitySummaryDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  title!: string
  @ApiProperty({ type: 'string' })
  typeId!: string
}

export class ActivityCompetencyLinkResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  activityId!: string
  @ApiProperty({ type: 'string' })
  programCompetencyId!: string
  @ApiProperty({ type: 'string' })
  targetLevel!: string
  @ApiProperty({ type: Number })
  weight!: number

  @ApiPropertyOptional({ type: () => ActivitySummaryDto })
  activity?: ActivitySummaryDto

  @ApiPropertyOptional({ description: 'Capabilities calculées', type: Object })
  capabilities?: Record<string, boolean>
}
